export default __webpack_public_path__ + "static/media/mbfcTower2.jpg?.d33fa7bf";